import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { API } from '@/lib/api';
import { httpRequest } from '@/lib/http';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const me = await httpRequest(`${API}/auth/me`);
      // Réponse non-objet (ex. proxy renvoyant index.html en 200, prerender react-snap)
      // → considérer comme déconnecté plutôt que truthy.
      if (me && typeof me === 'object' && !Array.isArray(me)) {
        setUser(me);
      } else {
        setUser(false);
      }
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('pending_analysis_token');
    if (!token) return;
    httpRequest(`${API}/analyses/claim`, {
      method: 'POST',
      body: { analysis_token: token },
    })
      .then(() => {
        localStorage.removeItem('pending_analysis_token');
      })
      .catch(() => {
        localStorage.removeItem('pending_analysis_token');
      });
  }, [user]);

  const logout = async () => {
    try {
      await httpRequest(`${API}/auth/logout`, { method: 'POST', body: {} });
    } catch { /* ignore */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
